import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel"];

  toggle() {
    this.panelTarget.classList.toggle("open");
  }

  hideButton(event) {
    event.stopPropagation(); // prevent triggering the toggle

    this.element.classList.add("animate__animated", "animate__fadeOutRight");
  }
}
